module.exports = __webpack_public_path__ + "./img/stock-full.f2aedfa28d754e782f2b6a23b2a8c33c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stock-full.png
// module id = ./src/assets/img/stock-full.png
// module chunks = 11